var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5Productos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    enableBackground: "new 0 0 70 70",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#D3444F",
    cx: 35,
    cy: 35,
    r: 35
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M37.446,30.621h15.522v16.534H37.446V30.621z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M36.159,28.045h16.81v-2.103c0-0.2-0.047-0.397-0.136-0.577l-3.278-6.549H36.506l-1.653,0.851v-1.613 c0-1.883-1.53-3.413-3.411-3.413H19.327c-1.882,0-3.412,1.53-3.412,3.413v32.627c0,2.818,2.292,5.11,5.109,5.11h26.835 c2.818,0,5.109-2.292,5.109-5.11v-0.95h-16.81c-0.711,0-1.288-0.577-1.288-1.288V29.334C34.871,28.622,35.448,28.045,36.159,28.045 L36.159,28.045z M29.702,26.153c0,0.433-0.217,0.836-0.577,1.074l-6.06,4.01c-0.43,0.282-1.002,0.281-1.43-0.006 c-0.353-0.236-0.569-0.644-0.569-1.068v-9.083c0-0.711,0.577-1.287,1.288-1.287h6.061c0.712,0,1.287,0.576,1.287,1.287V26.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M49.539,16.24v-3.12c0-0.71-0.577-1.288-1.288-1.288h-9.447c-0.713,0-1.289,0.578-1.289,1.288v3.12H49.539z "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Productos);
export default __webpack_public_path__ + "static/media/5-productos.4edf0f5b6514e381d8bbaf9d4f4455ee.svg";
export { ForwardRef as ReactComponent };